/**
 * Consulting-era colour ramps — V1, archived.
 *
 * Extracted 2026-08-30 from src/pages/Colors.tsx, which rendered them as 743
 * lines of inline JSX. That page is being retired (conflict №11) and these
 * ramps existed nowhere else, so retiring it would have made 149 swatches
 * unreachable — recoverable from git, but nobody digs in git for a colour ramp.
 *
 * Owner's ruling: keep them, just not in the foreground. They now render in the
 * archived section of the canon Colors page, below current canon.
 *
 * NOT canon. The current palette is the token set in src/index.css. These are
 * kept for older decks and exports that still cite them.
 *
 * Generated by extraction, not transcribed — 149 hexes typed by hand is the
 * failure mode this whole system has been fighting.
 */

export interface ConsultingRamp {
  name: string;
  /** The ramp's anchor value — the one the brand actually used. */
  anchor: string;
  hexes: string[];
}

export const CONSULTING_ERA_RAMPS: ConsultingRamp[] = [
  {
    name: "Slate Blue (consulting structural)",
    anchor: "#3D4B6F",
    hexes: ["#3D4B6F", "#FFFFFF", "#E8F1F9", "#C6D2E2", "#9FAEC9", "#64789E", "#51618A", "#313845", "#2B2F32", "#191A1C"],
  },
  {
    name: "Sage Green",
    anchor: "#5A7D5E",
    hexes: ["#5A7D5E", "#FFFFFF", "#F2F7F3", "#D9E8DC", "#B5D1BA", "#84B18C", "#6A9C73", "#465F49", "#354738", "#1E2A20"],
  },
  {
    name: "Alpine Green",
    anchor: "#53675B",
    hexes: ["#53675B", "#FFFFFF", "#E8F4EE", "#C6E1D2", "#A3CCB5", "#73AA8C", "#5E9876", "#497962", "#34423B", "#19241C"],
  },
  {
    name: "Granite Gray",
    anchor: "#9CA3AF",
    hexes: ["#9CA3AF", "#FFFFFF", "#F6F8FA", "#ECEFF3", "#DFE3EA", "#B7BCC6", "#808894", "#555D6A", "#393C43", "#1C1E22"],
  },
  {
    name: "Electric Mustard",
    anchor: "#E3B505",
    hexes: ["#E3B505", "#FFFFFF", "#FEF8DF", "#FCEEB5", "#FAE270", "#F4CF12", "#EFC708", "#E8C00A", "#B89003", "#9C7B02"],
  },
  {
    name: "Luminous Coral",
    anchor: "#F85E5E",
    hexes: ["#F85E5E", "#FFFFFF", "#FEEBEB", "#FDD6D6", "#FBB8B8", "#F78383", "#F26767", "#F14646", "#F73737", "#960D0D"],
  },
  {
    name: "Sienna — earthy accent",
    anchor: "#A28970",
    hexes: ["#FFFFFF", "#F6F2F0", "#E7DFDB", "#D6C6B8", "#B9A28B", "#A28970", "#584E47", "#302A26", "#211C18"],
  },
  {
    name: "Deep Ocean Teal",
    anchor: "#2F5C5B",
    hexes: ["#2F5C5B", "#FFFFFF", "#E8F4F3", "#C6E1DF", "#A3CCCA", "#73AA9A", "#4A7A7A", "#254A49", "#1C3837", "#0F1F1E"],
  },
  {
    name: "Terracotta Clay",
    anchor: "#C97A5B",
    hexes: ["#C97A5B", "#FFFFFF", "#FDF4F0", "#F9E3D6", "#F4D0B8", "#E8A885", "#D68B6A", "#B86A4A", "#8B4F36", "#5C3424"],
  },
  {
    name: "Sunlit Ochre",
    anchor: "#E8B86A",
    hexes: ["#E8B86A", "#FFFFFF", "#FEF9F0", "#FDF0D6", "#FBE5B8", "#F5D085", "#D4A55A", "#B8904A", "#7A5F31", "#3D2F18"],
  },
  {
    name: "Frosted Sky",
    anchor: "#AFC6D9",
    hexes: ["#AFC6D9", "#FFFFFF", "#F8FBFF", "#E8F1F9", "#D6E4F0", "#9BB3C7", "#87A0B5", "#738DA3", "#5F7A91", "#3D4B5C"],
  },
  {
    name: "Burnt Orange",
    anchor: "#D86B2D",
    hexes: ["#D86B2D", "#FFFFFF", "#FEF4ED", "#FDE4D1", "#FBD1B0", "#F6A86E", "#E87A4A", "#C55A22", "#9B4519", "#6B2F11"],
  },
  {
    name: "Olive Drab Green",
    anchor: "#6C7142",
    hexes: ["#6C7142", "#FFFFFF", "#F5F6F0", "#E8EBD8", "#D8DDB8", "#B8C088", "#9AA365", "#5A5E37", "#484B2C", "#2F311D"],
  },
  {
    name: "Muted Violet Gray",
    anchor: "#756D8A",
    hexes: ["#756D8A", "#FFFFFF", "#F7F6F9", "#EDEBF2", "#E1DEE8", "#C8C1D1", "#6A6278", "#5F5766", "#4A4350", "#2F2B33"],
  },
  {
    name: "Dusty Sand Beige",
    anchor: "#D8C6A8",
    hexes: ["#D8C6A8", "#FFFFFF", "#FDFCF9", "#FAF7F0", "#F5F0E4", "#C4B296", "#B09E84", "#9C8A72", "#7A6B58", "#4D4336"],
  },
];
